"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLessThanOrEqual = void 0;
exports.isLessThanOrEqual = (a, b) => a <= b;
//# sourceMappingURL=is-less-than-or-equal.js.map